require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-nicholas-hunt-walker.json") })
        }
      }, "path---blog-author-nicholas-hunt-walker");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-nicholas-hunt-walker!./.cache/json/blog-author-nicholas-hunt-walker.json
// module id = 693
// module chunks = 231608221292675